// extracted by mini-css-extract-plugin
export default {"image":"GmAL9","cnImage":"bI4P8"};